/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
const initialState = {
  loginUserDetails: null,
  hasPendingLogin: false,
  errormsg: null,
  forgetsucessmsg: null,
  forgeterrormsg: '',
  resetSuccess: {},
  resetFailure: {},
  userslist: null,
  deleteuser: null,
  validemailresult: null,
  sidebardataresult: null,
  usereditresult: null,
  addnewgroup: null,
  errornewgroup: '',
  groupData: null,
  selectedGroupData: null,
  licenseCount: 0,
};

const userReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'logincall':
      return {
        ...state,
        loginUserDetails: action.value,
        forgetsucessmsg: null,
      };
    case 'haspendinglogin':
      return {
        ...state,
        hasPendingLogin: action.value,
        forgetsucessmsg: null,
      };
    case 'errormsg':
      return {
        ...state,
        errormsg: action.value,
        forgetsucessmsg: null,
      };
    case 'forgeterrormsg':
      return {
        ...state,
        forgeterrormsg: action.value,
      };
    case 'GET_REMAINING_COUNT':
      return {
        ...state,
        getusersCount: action.value,
      };
    case 'forgetemailsuccessmessage':
      return {
        ...state,
        forgetsucessmsg: action.value,
        errormsg: null,
      };
    case 'resetmsg':
      return {
        ...state,
        resetSuccess: action.value,
      };
    case 'LINK_STORING_SUCCESS':
      return {
        ...state,
        linkNavigationUrl: action.value,
      };
    case 'reseterrormsg':
      return {
        ...state,
        resetFailure: action.value,
      };
    case 'userslist':
      return {
        ...state,
        userslist: action.value,
      };
    case 'errornewgroup':
      return {
        ...state,
        errornewgroup: action.value,
      };
    case 'NewGroupSuccess':
      return {
        ...state,
        addnewgroup: action.value,
      };
    case 'CLEAR_GROUP_VALUE':
      return {
        ...state,
        addnewgroup: '',
      };
    case 'GET_GROUP_VALUE':
      return {
        ...state,
        groupData: action.value,
      };
    case 'deleteusers':
      return {
        ...state,
        deleteuser: action.value,
      };
    case 'CLEAR_DELETE_USERS':
      return {
        ...state,
        deleteuser: '',
      };
    case 'validemail':
      return {
        ...state,
        validemailresult: action.value,
      };
    case 'adduser':
      return {
        ...state,
        adduserresult: action.value,
      };
    case 'CLEAR_ADDED_USERS':
      return {
        ...state,
        adduserresult: '',
      };
    case 'CLEAR_LOGIN_USER_SUCCESS':
      return {
        ...state,
        loginUserDetails: '',
        errormsg: '',
      };
    case 'sidebardata':
      return {
        ...state,
        sidebardataresult: action.value,
      };
    case 'usereditdata':
      return {
        ...state,
        usereditresult: action.value,
      };
    case 'CLEAR_EDITED_USERS':
      return {
        ...state,
        usereditresult: '',
      };
    case 'GET_SELECTED_GROUP_VALUE':
      return {
        ...state,
        selectedGroupData: action.value,
      };
    case 'GET_LICENSE_COUNT':
      return {
        ...state,
        licenseCount: action.value,
      };
    default:
      return state;
  }
};

export default userReducer;
